/** Nest API origin (no trailing slash). Must be provided via env. */
const rawApiBaseUrl = process.env.REACT_APP_API_URL?.trim();
if (!rawApiBaseUrl) {
  throw new Error(
    'Missing REACT_APP_API_URL. Set it in .env.development, .env.local, or your deployment environment.',
  );
}
export const API_BASE_URL = rawApiBaseUrl.replace(/\/$/, '');

/** Admin orders list path (must match your Nest controller, e.g. `/orders` or `/admin/orders`). */
export const ORDERS_LIST_PATH =
  (process.env.REACT_APP_ORDERS_PATH || '/orders').replace(/\/$/, '') || '/orders';

/** Guest checkout — no login required (backend must implement this route). */
export const GUEST_ORDERS_PATH =
  (process.env.REACT_APP_GUEST_ORDERS_PATH || '/orders/guest').replace(/\/$/, '') ||
  '/orders/guest';
